import Button from "@components/form/Button";
import FormRow from "@components/form/FormRow";
import useConsultancySignUpContext from "../context/useConsultancySignUpContext";
import { growthDiscordUrl } from "@lib/constants/generic";
import { FaDiscord } from "react-icons/fa";

export default function CompletionStep() {
  const { onClose } = useConsultancySignUpContext();

  return (
    <>
      <FormRow className="completion-text-row">
        <p>
          We can't take payment at this time. Our Q1 2023 Cohort is currently full.
          <br />
          <br />
          We'll be in touch as soon as we open up applications for Q2.
        </p>
      </FormRow>

      <div className="auth-button-row">
        <Button
          color="purple"
          textColor="white"
          size="large"
          endIcon={<FaDiscord />}
          href={growthDiscordUrl}
          openInNewTab
          justifyContent="center">
          Join Discord
        </Button>
        <Button
          color="gray-1"
          textColor="white"
          size="large"
          justifyContent="center"
          onClick={onClose}>
          Close
        </Button>
      </div>
    </>
  );
}
